export function generateOrganizationUrl(
  slug: string,
  wlSubdomain: string,
  customDomain?: string | null
): string {
  if (!slug || !wlSubdomain) {
    return `/admin/organization/${slug}`;
  }

  const rootDomain = process.env["NEXT_PUBLIC_ROOT_DOMAIN"] || "";
  const baseDomain = customDomain || rootDomain;
  const protocol = process.env.NODE_ENV === "development" ? "http" : "https";

  return `${protocol}://${wlSubdomain}.${baseDomain}/admin/organization/${slug}`;
}

export function getOrganizationDomainUrl(): {
  domainPrefix: string;
  baseDomain: string;
} {
  const baseDomain = process.env["NEXT_PUBLIC_ROOT_DOMAIN"] || "";

  return { domainPrefix: "", baseDomain };
}
